import { useMutation } from "@apollo/client"
import { Alert } from "@blueprintjs/core"
import AppToaster from "utils/AppToaster"
import React from "react"
import { graphqlError } from "utils/parseError"
const AlertDialogue = ({
  isOpen,
  onClose,
  alertFor,
  mutation,
  variables = undefined,
  refetchQueries = undefined,
  optimisticResponse = undefined,
  update = undefined,
  confirmButtonText,
}) => {
  const [mutationFunction] = useMutation(mutation, {
    variables,
    onCompleted: () => {
      AppToaster.show({
        message: `${alertFor} Archived Successfully`,
        intent: "success",
        icon: "tick",
      })
    },
    onError: ({ message }) => {
      AppToaster.show({
        message: graphqlError(message),
        intent: "warning",
        icon: "cross",
      })
    },
  })
  return (
    <Alert
      icon="projects"
      intent="danger"
      confirmButtonText={confirmButtonText}
      canEscapeKeyCancel={false}
      cancelButtonText="Cancel"
      isOpen={isOpen}
      onClose={() => onClose(false)}
      onConfirm={() => {
        mutationFunction({ update, optimisticResponse, refetchQueries })
      }}
    >
      <p>Are You Sure you want to archive the {alertFor}?</p>
    </Alert>
  )
}
AlertDialogue.defaultProps = {
  confirmButtonText: "Delete",
}
export default AlertDialogue
